import { BaseRouteService } from 'core/services';

class PatientDetailRouteService extends BaseRouteService {
    constructor() {
        super('patient-details');
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields,patientDetailDiagnosisCodes}', id, options);
    }
    
    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    import(resource) {
        return super.update(this.base + '/import/{id}', resource);
    }

    findStates(searchTerm) {
        return super.find(this.base + '/states/{?searchQuery}', { searchQuery : searchTerm});
    }
}

export default PatientDetailRouteService;
